import { useCallback, useMemo, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Card } from '@altermaind/web/ui';
import { useDrawer } from '@/_shared/components/Drawer';
import { StyledTableDrawer, usePaginatedTable } from '@/_shared/components/Table';
import { TableHeader } from '@/_shared/components/TableHeader';
import { useDialog } from '@/_shared/hooks/useDialog';
import { Employer, getEmployeesCall } from '../../state';
import { PAGE_SIZE_EMPLOYEES } from '../../state/constants';
import { FiltersEmployees } from '../FiltersEmployees';
import { TableEmployees } from '../TableEmployees';

export const EmployeesList = () => {
  const t = useTranslations('people.tableEmployees');
  const [selectedEmployer, setSelectedEmployer] = useState<Employer>();
  const { openDialog: openAddEmployeeChoice } = useDialog('addEmployeeChoice');
  const { isOpen, close, ...drawerProps } = useDrawer();
  const [filters, setFilters] = useState<{ q: string; departments?: string[]; roles?: string[] }>();

  const { data, totalItems } = getEmployeesCall.hook();

  const paginedProps = usePaginatedTable({
    rowData: data || [],
    pageSize: PAGE_SIZE_EMPLOYEES,
    totalItems,
  });

  const drawers: StyledTableDrawer['instances'] = [];

  const goToPeopleImport = useCallback(() => {
    openAddEmployeeChoice();
  }, [openAddEmployeeChoice]);

  const onSearchCallback = useCallback(
    (value: string) => {
      setFilters(prev => ({ ...prev, q: value }));
    },
    [setFilters],
  );

  const activeFiltersCount = useMemo(() => {
    return (filters?.departments?.length || 0) + (filters?.roles?.length || 0);
  }, [filters?.departments?.length, filters?.roles?.length]);

  return (
    <Card overflow='visible' mt='xs' display='flex' flexDirection='column'>
      <TableHeader
        onSearchCallback={onSearchCallback}
        title={t('title')}
        buttonAddOnClick={goToPeopleImport}
        data-testid='employee-button'
        filtersComponent={<FiltersEmployees setFilters={setFilters} filters={filters} />}
        activeFiltersCount={activeFiltersCount}
      />
      <TableEmployees
        setSelectedEmployer={setSelectedEmployer}
        selectedEmployer={selectedEmployer}
        paginedProps={paginedProps}
        drawer={{ ...drawerProps, isOpen, close, instances: drawers }}
        filters={filters}
        showCheckboxes
      />
    </Card>
  );
};
